import { render, staticRenderFns } from "./widgetEmailRecipientInput.vue?vue&type=template&id=64d3ee68&scoped=true"
import script from "./widgetEmailRecipientInput.vue?vue&type=script&lang=js"
export * from "./widgetEmailRecipientInput.vue?vue&type=script&lang=js"
import style0 from "./widgetEmailRecipientInput.vue?vue&type=style&index=0&id=64d3ee68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3ee68",
  null
  
)

export default component.exports